"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_UPSELL = void 0;
var BULLETS = [
    {
        BOLD: true,
        BODY: 'Help raise your credit score by 45 points in 1 month*'
    },
    {
        BOLD: false,
        BODY: 'Save money on future purchases like a car loan or mortgage**'
    },
    {
        BOLD: false,
        BODY: 'Track your credit score and watch it increase just by paying rent'
    },
];
exports.CREDIT_BUILDER_UPSELL = {
    HEADER: 'You don’t qualify for Flexible Rent (yet!) but Credit Builder can help',
    REJECT_CTA: 'No thanks',
    CTA: 'Set up Credit Builder',
    DISCLAIMER: '*Based on real customers data with a starting score below 560.',
    DISCLAIMER_LINK: 'Learn more',
    DISCLAIMER_TWO: '**Individual results vary. Average outcome for customers who opened a Credit Builder account for use in September 2024 with a starting VantageScore 3.0 with a credit score below 560 and made consistent, on-time payments for at least one month. Factors other than on time payments, including interactions with other creditors, also play a role and may impact results. Payment history will be reported to TransUnion. Past performance does not guarantee future results, and a credit score increase is not guaranteed.',
    LIST_HEADER: 'Pay your rent in full each month to...',
    BULLETS: BULLETS
};
